<script setup lang="ts"></script>

<template>
  <header class="flex w-full bg-black">
    <img src="/lactel/images/header.png" alt="Lactel Logo" class="contain w-full object-center" />
  </header>
</template>
